// extracted by mini-css-extract-plugin
export default {"scannerBox":"styles_scannerBox__XwaU6"};